var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "20px",
    viewBox: "0 0 23 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "campaignDetails",
    transform: "translate(2.000000, 0.000000)",
    stroke: "currentColor",
    strokeWidth: 2.08333333
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,12.4615387 C13,13.3112074 12.2796661,14 11.3910891,14 L1.60891087,14 C0.72033394,14 0,13.3112074 0,12.4615387 L0,4.53846129 C0,3.68879262 0.72033394,3 1.60891087,3 L5.63118816,3 L7.24009902,5.30769231 L11.3910891,5.30769231 C12.2796661,5.30769231 13,5.99648492 13,6.8461536 L13,12.4615387 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,12.2916667 L20.75,12.2916667",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,7.04166667 L20.75,7.04166667",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.375,1.04166667 L20.75,1.04166667",
    id: "Path-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.5416667 L20.75,18.5416667",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignDetails);
export default __webpack_public_path__ + "static/media/campaignDetails.acd2d9a40f386e22510eca17dda1dfe5.svg";
export { ForwardRef as ReactComponent };